import HighlightedText from 'Components/Atoms/HighlightedText/HighlightedText';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import Loader, { LOADER_SIZE } from 'Components/Atoms/Loader/Loader';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import TagGroup from 'Components/Molecules/TagGroup/TagGroup';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { getAccessTokenFromLocal, getEntityRouteByInternalDataset, InternalDatasets, useOuterClick } from 'Services/helpers';
import { fetchBusinessDataset } from 'Store/Business/Actions';
import { getBusinessDataset } from 'Store/Business/Selectors';
import { fetchBusinessUnitDataset } from 'Store/BusinessUnit/Actions';
import { getBusinessUnitDataset, getBusinessUnitDatasetKeys } from 'Store/BusinessUnit/Selectors';
import { fetchCandidateDataset } from 'Store/Candidate/Actions';
import { getCandidateDataset, getCandidateDatasetKeys } from 'Store/Candidate/Selectors';
import { fetchContactDataset } from 'Store/Contact/Actions';
import { getContactDataset, getContactDatasetKeys } from 'Store/Contact/Selectors';
import { fetchAllDatasets } from 'Store/FieldManagement/Actions';
import { getAllDatasets, getDatasetByIds, getDatasetLabels, getDatasetPathById, getRootDatasets } from 'Store/FieldManagement/Selectors';
import { StoreState } from 'Store/Reducers';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';
import { fetchUsersDataset } from 'Store/User/Actions';
import { getUserDataset, getUserDatasetKeys } from 'Store/User/Selectors';
import { fetchVacancyDataset } from 'Store/Vacancy/Actions';
import { getVacancyDataset } from 'Store/Vacancy/Selectors';
import styles from './DropdownField.module.sass';
import DropdownFieldDropdownItem from './DropdownFieldDropdownItem';

const DropdownField = ({isEdit, onChange, value: rawValue, fieldProperties, ...props }: DropdownProps) => {
    const isEmpty = !rawValue || !Array.isArray(rawValue) || rawValue?.length == 0;
    const [searchTimer, setSearchTimer] = useState<any>(null);
    const [data, setData] = useState<any>({
        key: fieldProperties?.dataset?.dataset?.length > 0 ? fieldProperties?.dataset?.dataset[0] : null,

        original: props.datasets || [],
        originalKeys: [],
        originalFilterValue: [],

        relationKeys: [],
        relationFilterValue: [],
        relationInput: [],
        relations: [],

        filterValue: [],
        filtered: [],
        
        page: 0,
        pageSize: 50,
        totalPages: 0,
        searchQuery: '',
        activePath: [],
        debounceDelay: fieldProperties?.debounceDelay || 150
    });
    const [state, setState] = useState<any>({
        isFocused: false,
        isLoading: false,
        isFilterable: false,
        isFiltering: false,
        isPaginated: true,
        isMultiLevel: false,
        rootDatasetsOnly: !!fieldProperties?.allowInternal || !!fieldProperties?.allowCustoms,
    });
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => {
        setState({...state, isFocused: false});
        setData({...data, searchQuery: ''});
    });

    const handleFocusClick = () => {
        if (fieldProperties?.isDisabled) return;
        setState({...state, isFocused: true});
        setTimeout(() => inputRef?.current?.focus(), 100);

        if (!state.rootDatasetsOnly && data.page == 0) prepareDatasets();
    }

    const resetDatasets = () => {
        if (state.isMultiLevel) {
            const filtered = data?.filterValue.map((item: any) => item?.path || [item?.id]);
            setData({
                ...data,
                relationKeys: [],
                relationFilterValue: [],
                relationInput: [],
                relations: [],
                filterValue: data.originalFilterValue,
                filtered: filterDataset(filtered)
            });
            
            return;
        }

        setData({
            ...data,
            relationKeys: [],
            relationFilterValue: [],
            relationInput: [],
            relations: [],
            filterValue: data.originalFilterValue,
            filtered: getFilterPage()
        });
    }

    const resetRelationDataset = () => {
        setData({
            ...data,
            relationKeys: [],
            relationFilterValue: [],
            relationInput: [],
            relations: [],
            filterValue: data.originalFilterValue,
            filtered: getFilterPage(1, state.isMultiLevel ? data.originalFilterValue : data.originalKeys, state.isMultiLevel)
        });
        setState((state) => ({
            ...state,
            isPaginated: true
        }));
    }

    const fetchDatasets = async () => {
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                await props.fetchCandidateDataset();
                break;
            case InternalDatasets.VACANCIES:
                await props.fetchVacancyDataset();
                break;
            case InternalDatasets.BUSINESS:
                await props.fetchBusinessDataset();
                break;
            case InternalDatasets.BUSINESS_UNITS:
                await props.fetchBusinessUnitDataset();
                break;
            case InternalDatasets.CONTACT:
                await props.fetchContactDataset();
                break;
            case InternalDatasets.USERS:
                await props.fetchUsersDataset();
                break;
            default:
                await props.fetchAllDatasets();
                break;
        }
    }

    const prepareDatasets = () => {
        let dataset = {};
        let datasetKeys: any[] = [];
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                dataset = props.candidateDataset;
                datasetKeys = props.candidateDatasetKeys;
                break;
            case InternalDatasets.VACANCIES:
                dataset = props.vacancyDataset;
                break;
            case InternalDatasets.BUSINESS:
                dataset = props.businessDataset;
                break;
            case InternalDatasets.BUSINESS_UNITS:
                dataset = props.businessUnitDataset;
                datasetKeys = props.businessUnitDatasetKeys;
                break;
            case InternalDatasets.CONTACT:
                dataset = props.contactDataset;
                datasetKeys = props.contactDatasetKeys;
                break;
            case InternalDatasets.USERS:
                dataset = props.userDataset;
                datasetKeys = props.userDatasetKeys;
                break;
            default:
                console.log(data.key);
                if (data.key) {
                    dataset = props.datasetById[data.key];
                    datasetKeys = props.datasetById[data.key];
                } else {
                    dataset = props.datasets;
                    datasetKeys = props.datasets;
                }
        }

        let datasetFilterValue: any = [];
        const pushDatasetFilter = (id, value, path: any = undefined) => {
            datasetFilterValue.push({
                ...(path && { path: path } ),
                id: id,
                value: value
            });
        }

        const loop = (datasetKeys, path: any[] = []) => {
            datasetKeys.map((item: any) => {
                const newPath = [...path, item.value];
                if (item.children) { loop(item.children, newPath) }

                pushDatasetFilter(item.value, item.title.toLowerCase(), newPath);
            });
        }

        let isMultiLevel = state.isMultiLevel;
        for (const key of Object.keys(dataset)) {
            if (data.key >= 0) {
                const item = dataset[key];
                if (item.children) {
                    if (state.isPaginated) {
                        isMultiLevel = true;
                    }

                    loop(item.children, [item.value]);
                    continue;
                }

                pushDatasetFilter(item.value, item.title.toLowerCase());
                
                continue;
            }

            if (data.key == InternalDatasets.USERS) {
                pushDatasetFilter(key, dataset[key].name + ' ' + dataset[key].email);

                continue;
            }
            
            pushDatasetFilter(key, dataset[key].toLowerCase());
        }

        const a = {
            ...data,
            original: dataset,
            originalKeys: datasetKeys,
            originalFilterValue: datasetFilterValue,
            filterValue: datasetFilterValue,
            filtered: getFilterPage(1, state.isMultiLevel ? datasetFilterValue : datasetKeys),
            page: 1,
            totalPages: Math.round(datasetKeys.length / data.pageSize)
        }

        if (state.isMultiLevel && rawValue && rawValue[0]) {
            a.activePaths = datasetFilterValue.find((item: any) => item.id == rawValue[0])?.path;
        }

        setData(a);
        setState({
            ...state,
            isFocused: true,
            isMultiLevel: isMultiLevel,
            isPaginated: !isMultiLevel
        });
    }

    const filterDataset = (filtered: any) => {
        let filteredItems: any = [];
        let rootMap: any = [];
        let hashMap = {};
        
        filtered.map((item: any) => {
            item.forEach((a: any, index: any) => {
                if (!rootMap.includes(a) && index == 0) {
                    rootMap.push(a);
                }

                const nextItem = item[index+1];
                if (!hashMap[a] && nextItem) {
                    hashMap[a] = [];
                }
                if (nextItem) {
                    if (!hashMap[a].includes(nextItem)) {
                        hashMap[a].push(nextItem);
                    }
                }
            });
        });

        const loop = (hash: any) => {
            let output: any = [];
            hash.forEach((key) => {
                if (!hashMap[key]) {
                    return output.push({ id: key });
                }
                
                output.push({
                    id: key,
                    children: loop(hashMap[key])
                });
            });

            return output;
        };

        rootMap.forEach((key) => {
            if (!hashMap[key]) {
                return filteredItems.push({ id: key });
            }

            return filteredItems.push({
                id: key,
                children: loop(hashMap[key])
            });
        });

        return filteredItems;
    }

    const getFilterPage = (page: number = 1, datasetKeys: any = null, isMultiLevel = false) => {
        if (state.isMultiLevel) {
            const filtered = (datasetKeys || data.filterValue)
                .map((item: any) => item?.path || [item?.id]);

            return filterDataset(filtered);
        }

        return (datasetKeys || data.originalKeys)
            .slice(0, page * data.pageSize)
            .map((item) => ({ id: item?.value || item }));
    };

    const labels = (id, labelForList = false) => {
        let output = {};
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                output = {
                    label: props.candidateDataset[id] || '',
                    url: getEntityRouteByInternalDataset(data.key, id)
                }
                break;
            case InternalDatasets.VACANCIES:
                output = {
                    label: props.vacancyDataset[id] || '',
                    url: getEntityRouteByInternalDataset(data.key, id)
                }
                break;
            case InternalDatasets.BUSINESS:
                output = {
                    label: props.businessDataset[id] || '',
                    url: getEntityRouteByInternalDataset(data.key, id)
                }
                break;
            case InternalDatasets.BUSINESS_UNITS:
                output = {
                    label: props.businessUnitDataset[id] || '',
                    url: getEntityRouteByInternalDataset(data.key, id)
                }
                break;
            case InternalDatasets.CONTACT:
                output = {
                    label: props.contactDataset[id] || '',
                    url: getEntityRouteByInternalDataset(data.key, id)
                }
                break;
            case InternalDatasets.USERS:
                if (labelForList) {
                    output = { label: `${props.userDataset[id]?.name} (${props.userDataset[id]?.email})`}
                } else {
                    output = { label: props.userDataset[id]?.name || ''};
                }
                break;
            default:
                if (!props.datasetPathById) {
                    output = {
                        label: 'Laden...',
                        path: 'Laden...'
                    };

                    break;
                }

                let label, path = '';
                const datasetPath = props.datasetPathById[id];

                if (Array.isArray(datasetPath)) {
                    datasetPath.forEach((item: any, index: number, array: any[]) => {
                        if (array.length >= 3 && index == 0) {
                            label = '../' + props.datasetLabels[id];
                        } else if (array.length < 3) {
                            label = props.datasetLabels[id];
                        } else {
                            path += ((index >= 2) ? '/' : '') + props.datasetLabels[item];
                        }
                    });
                }

                output = { label, path };
        }
        
        return { ...output, value: id };
    }

    const getLabel = (id) => {
        if (state.rootDatasetsOnly) {
            switch (id) {
                case InternalDatasets.BUSINESS:
                    return {
                        label: 'Bedrijven (OLD)',
                        path: 'Bedrijven (OLD)'
                    };
                case InternalDatasets.BUSINESS_UNITS:
                    return {
                        label: 'Bedrijven',
                        path: 'Bedrijven'
                    };
                case InternalDatasets.CANDIDATES:
                    return {
                        label: 'Kandidaten',
                        path: 'Kandidaten'
                    };
                case InternalDatasets.CONTACT:
                    return {
                        label: 'Contactpersonen',
                        path: 'Contactpersonen'
                    };
                case InternalDatasets.USERS:
                    return {
                        label: 'Gebruikers',
                        path: 'Gebruikers'
                    };
                case InternalDatasets.VACANCIES:
                    return {
                        label: 'Vacatures',
                        path: 'Vacatures'
                    };
                default:
                    return {
                        label: props.datasetLabels[id]
                    };
            }
        };
        
        return labels(id);
    };
    const getDatasetLabel = (id) => labels(id, true);

    const InternalDatasetMap = [
        {
            ...getLabel(InternalDatasets.BUSINESS_UNITS),
            value: InternalDatasets.BUSINESS_UNITS
        }, {
            ...getLabel(InternalDatasets.CANDIDATES),
            value: InternalDatasets.CANDIDATES
        }, {
            ...getLabel(InternalDatasets.CONTACT),
            value: InternalDatasets.CONTACT
        }, {
            ...getLabel(InternalDatasets.USERS),
            value: InternalDatasets.USERS
        }, {
            ...getLabel(InternalDatasets.VACANCIES),
            value: InternalDatasets.VACANCIES
        }
    ];

    const handleClick = (a: any) => {
        let newValues = [a];
        if (a == null) {
            newValues = [];
        }

        onChange(newValues);
        setData({...data, searchQuery: ''});
        setState((state) => ({...state, isFocused: false}));
    }

    const loadMoreRef: any = useRef();
    const handleScroll = (e) => {
        if (!state.isPaginated) return;
        if (data.page == data.totalPages) return;

        const bottomThreshold = e.currentTarget.scrollHeight - e.target.scrollTop <= e.target.clientHeight * 3;
        if (bottomThreshold) { 
            const nextPage = data.page + 1;

            setData({
                ...data,
                filtered: getFilterPage(nextPage),
                page: nextPage
            });
        }
    }

    useEffect(() => {
        if (!data?.originalFilterValue) return; 
        if (searchTimer) {
            clearTimeout(searchTimer);
            setSearchTimer(null);
        }

        if (data.searchQuery == '') {
            clearTimeout(searchTimer);
            setSearchTimer(null);

            setState((state) => ({
                ...state,
                isFiltering: false
            }));
            
            if (fieldProperties?.inRelation == undefined || fieldProperties?.inRelation?.length == 0) {
                resetRelationDataset();
    
                return;
            }

            resetDatasets();

            return;
        }

        setState((state) => ({...state, isFiltering: true}));
        setSearchTimer(
            setTimeout(() => {
                setState({...state, isFiltering: false});

                const searchQuery = data.searchQuery.trim().toLowerCase();
                if (state.isMultiLevel) {
                    const filtered = data?.filterValue
                        .filter((item: any) => item.value.includes(searchQuery))
                        .map((item: any) => item?.path || [item?.id]);

                    setData({...data, filtered: filterDataset(filtered)});
                    
                    return;
                }

                setData({...data, filtered: data?.filterValue
                    .filter((item: any) => item.value.includes(searchQuery))
                    .map((item: any) => ({ id: item.id }))});
            }, data.debounceDelay)
        );
    }, [data.searchQuery]);

    const fetchRelations = async () => {
        const accessToken = getAccessTokenFromLocal();

        const preparedRelationValues = fieldProperties?.inRelation.join(',');
        fetch(`${API_URL}/api/field-management/relations/${preparedRelationValues}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        )
            .then(r => r.json())
            .then((response: any) => {
                const relationValues = response?.data;
                const relationFilterValue = data.originalFilterValue.filter((item: any) => relationValues.includes(item.id?.toString()));
                if (relationFilterValue.length <= 0) {
                    setData({
                        ...data,
                        relationKeys: [],
                        relationFilterValue: [],
                        relationInput: [],
                        relations: [],
                        filterValue: data.originalFilterValue,
                        filtered: getFilterPage(1, state.isMultiLevel ? state.originalFilterValue : state.originalKeys, state.isMultiLevel)
                    });
                    setState((state) => ({
                        ...state,
                        isPaginated: true,
                        isLoading: false
                    }));
                    
                    return;
                }
                
                const relationFiltered = filterDataset(relationFilterValue.map((item: any) => item?.path || [item?.id]));
                
                setData({
                    ...data,
                    relationFilterValue: relationFilterValue,
                    relations: response?.data,
                    relationInput: fieldProperties?.inRelation, 
                    filterValue: relationFilterValue,
                    filtered: relationFiltered
                });
            });
    }

    useEffect(() => {
        setState((state) => ({...state, isLoading: false}));
    }, [data.filterValue]);

    useEffect(() => {
        if (!state.isFocused) return;
        const hasRelation = fieldProperties?.inRelation?.length > 0;
        if (hasRelation) {
            const relations = fieldProperties?.inRelation;
            const hasRelationValueChanged = relations?.length != data.relationInput.length || !data.relationInput.every((val, idx) => val == relations[idx]);
            if (hasRelationValueChanged) {
                setState((state) => ({
                    ...state,
                    isPaginated: false,
                    isLoading: true
                }));    
                fetchRelations();

                return;
            }

            const relationFiltered = filterDataset(data.relationFilterValue.map((item: any) => item?.path || [item?.id]));
            setData({
                ...data,
                filterValue: data.relationFilterValue,
                filtered: relationFiltered
            });

            return;
        }

        resetRelationDataset();
    }, [state.isFocused]);

    useEffect(() => {
        fetchDatasets();
    }, [fieldProperties?.dataset?.dataset]);
    
    const getRootDatasets = () => props.rootDatasets
        .map((id: any) => ({ id: id, ...getLabel(id) }))
        .filter((item: any) => item.label.toLowerCase().includes(data.searchQuery));
    
    if (!isEdit) {
        if (isEmpty) {
            return <NoValue />;
        }

        return <TagGroup
            alignRight={!fieldProperties.alignLeft}
            isCollapsed={fieldProperties.isInline}
        >
            {   
                rawValue.map((id: any) => {
                    const item: any = getLabel(id);

                    return <Tag
                        key={id}
                        url={item?.url}
                        tooltip={item?.path}
                    >
                        { item?.label }
                    </Tag>;
                })
            }
        </TagGroup>
    }

    return <div className={`${styles['dropdown']} ${state.isFocused ? styles['dropdown--active'] : ''} ${fieldProperties?.isDisabled ? styles['dropdown--disabled'] : ''}`} ref={innerRef}>
        <div className={styles['dropdown__content']} onClick={handleFocusClick}>
            { (!isEmpty && rawValue?.length > 0) && <TagGroup>
                { 
                    rawValue.map((id: any) => {
                        const item: any = getLabel(id);
                        
                        return <Tag key={id} transparent>
                            { item?.label }
                        </Tag>;
                    })
                }
            </TagGroup> }
            { ((isEmpty && !state.isFocused) || rawValue?.length == 0) && <input placeholder={'Selecteer een waarde...'} style={{pointerEvents: 'none'}}/> }
            {
                state.isFocused && <input
                    placeholder={'Typ hier om te filteren...'}
                    value={data.searchQuery}
                    onChange={(e) => setData({...data, searchQuery: e.target.value})}
                    ref={inputRef}
                />
            }
        </div>
        {
            rawValue?.length > 0 &&
            <div className={styles['dropdown__icon']} onClick={() => handleClick(null)}>
                <Icon type={ICONS.CLOSE} size={'xsmall'} isCircled />
            </div>
        }
        <div className={styles['dropdown__icon']} onClick={handleFocusClick}>
            <Icon type={ICONS.CHEVRON_DOWN} size={'small'}/>
        </div>
        
        {
            !state.rootDatasetsOnly &&
            state.isFocused && 
            <div className={styles['dropdown__dropdown']} onScroll={handleScroll}>
                {
                    !state.isFiltering &&
                    !state.isLoading && <>
                        {
                            data?.filtered?.map((item: any, index: any) => {
                                if (data.key >= 0) {
                                    return <DropdownFieldDropdownItem
                                        key={item.id}
                                        item={item}
                                        labels={props.datasetLabels}
                                        searchQuery={data.searchQuery}
                                        activeValues={data.activePaths}
                                        onClick={(v) => handleClick(v)}
                                    />
                                } else {
                                    const { label }: any = getDatasetLabel(item.id);
                                    
                                    return <div
                                        className={`${styles['dropdown__item']} ${rawValue?.includes(item.id) ? styles['dropdown__item--active'] : ''}`}
                                        key={item.id}
                                        ref={data.filtered.length-1 == index ? loadMoreRef : undefined}
                                        onClick={() => handleClick(item.id)}
                                    >
                                        <HighlightedText highlight={data.searchQuery}>{label}</HighlightedText>
                                    </div>;
                                }
                            })
                        }
                    </>
                }
                { 
                    data?.filtered?.length == 0 &&
                    !state.isLoading && <div className={`${styles['dropdown__item']}`}>Geen resultaten gevonden...</div> }
                { (state.isFiltering || state.isLoading) && <Loader size={LOADER_SIZE.MEDIUM} /> }
            </div> }
        {
            state.rootDatasetsOnly &&
            state.isFocused &&
            <div className={styles['dropdown__dropdown']} onScroll={handleScroll}>
                {
                    fieldProperties?.allowInternal && <>
                        <strong style={{pointerEvents: 'none'}} className={styles['dropdown__dropdown__item']}>Interne datasets</strong>
                        {
                            InternalDatasetMap.filter((item: any) => item.label.toLowerCase().includes(data.searchQuery)).map((item: any, i: any, a: any) => {
                                return <div className={`${styles['dropdown__dropdown__item']}`} onClick={() => handleClick(item.value)}>
                                    <HighlightedText highlight={data.searchQuery}>{ item.label }</HighlightedText>
                                </div>; 
                            })
                        }
                        {
                            InternalDatasetMap.filter((item: any) => item.label.toLowerCase().includes(data.searchQuery)).length == 0 &&
                            <div className={`${styles['dropdown__dropdown__item']}`} style={{fontStyle: 'italic'}}>
                                Geen resultaten gevonden...
                            </div>
                        }
                    </>
                }
                {
                    fieldProperties?.allowCustoms && <>
                        <strong style={{pointerEvents: 'none'}} className={styles['dropdown__dropdown__item']}>Customs datasets</strong>
                        {
                            getRootDatasets()
                                .map((item: any) => {
                                    return <div className={`${styles['dropdown__dropdown__item']}`} onClick={() => handleClick(item.id)}>
                                        <HighlightedText highlight={data.searchQuery}>{ item.label }</HighlightedText>
                                    </div>
                                })
                        }
                        {
                            getRootDatasets().length == 0 &&
                            <div className={`${styles['dropdown__dropdown__item']}`} style={{fontStyle: 'italic'}}>
                                Geen resultaten gevonden...
                            </div>
                        }
                    </>
                }
            </div>
        }
    </div>;
}

interface Props {
    isEdit: boolean,
    onChange: (value: any) => any,
    value: any[],
    fieldProperties: {
        allowInternal: boolean | undefined,
        allowCustoms: boolean | undefined,
        isInline: boolean | undefined,
        alignLeft: boolean | undefined,
        isDisabled: boolean | undefined,
        inRelation: any[],
        dataset: {
            dataset: string[],
            value: string[]
        },
        debounceDelay?: number
    }
}

const mapState = (state: StoreState) => ({
    datasets: getAllDatasets(state),
    datasetLabels: getDatasetLabels(state),
    datasetById: getDatasetByIds(state),
    datasetPathById: getDatasetPathById(state),
    rootDatasets: getRootDatasets(state),
    candidateDataset: getCandidateDataset(state),
    candidateDatasetKeys: getCandidateDatasetKeys(state),
    vacancyDataset: getVacancyDataset(state),
    contactDataset: getContactDataset(state),
    contactDatasetKeys: getContactDatasetKeys(state),
    businessDataset: getBusinessDataset(state),
    businessUnitDataset: getBusinessUnitDataset(state),
    businessUnitDatasetKeys: getBusinessUnitDatasetKeys(state),
    userDataset: getUserDataset(state),
    userDatasetKeys: getUserDatasetKeys(state)
});

const mapDispatch = {
    fetchAllDatasets,
    fetchCandidateDataset,
    fetchVacancyDataset,
    fetchContactDataset,
    fetchBusinessDataset,
    fetchBusinessUnitDataset,
    fetchUsersDataset
};

type DropdownProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(DropdownField);